import { useEffect, useState } from "react";
import { Select, SelectItem, Notice } from "@conuti-das/prince-ui";
import { Spinner } from "@/ui-prince";
import { validatorApi, type Formatversion } from "@/api/validatorApi";

interface Props {
  value: string;
  onChange: (id: string) => void;
}

export function BundleSelector({ value, onChange }: Props) {
  const [formatversions, setFormatversions] = useState<Formatversion[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    validatorApi
      .getFormatversions()
      .then((fvs) => {
        setFormatversions(fvs);
        if (!value && fvs.length > 0) onChange(fvs[0].id);
      })
      .catch((e) => setError(String(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <Notice tone="negative">
        Formatversion-Liste fehlgeschlagen: {error}
      </Notice>
    );
  }
  if (formatversions === null) {
    return (
      <span style={{ display: "flex", alignItems: "center", gap: "var(--s-2)", fontSize: "0.85rem", color: "var(--sapContent_LabelColor)" }}>
        <Spinner size="s" />
        Lade Formatversionen ...
      </span>
    );
  }
  if (formatversions.length === 0) {
    return (
      <Notice tone="info">
        Keine Formatversionen verfügbar.
      </Notice>
    );
  }

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "var(--s-2)" }}>
      <label htmlFor="formatversion-select" className="prn-field-label">
        Formatversion <span aria-hidden="true">*</span>
      </label>
      <Select
        id="formatversion-select"
        selectedKey={value || null}
        onSelectionChange={(key) => {
          if (key != null) onChange(String(key));
        }}
        aria-label="Formatversion auswählen"
        placeholder="Formatversion wählen ..."
        style={{ minWidth: "320px" }}
      >
        {formatversions.map((fv) => (
          <SelectItem key={fv.id} id={fv.id}>
            {fv.id} ({fv.counts.pruefids ?? "?"} Prüfids · {fv.counts.msgtypes ?? "?"} MsgTypes ·{" "}
            {fv.counts.conditions ?? "?"} Conds)
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}
